import { Inject, Injectable, Injector }from '@angular/core';

import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.FootPrintPortalManager = this.injector.get(FootPrintPortalManager_DatasourceService);
  }

    public FootPrintPortalManager: FootPrintPortalManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

